import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.625 16.251H19l-1.23-1.249a1.82 1.82 0 0 1-.52-1.277v-2.807c0-2.322-1.46-4.298-3.5-5.03v-.304c0-.981-.784-1.777-1.75-1.777s-1.75.796-1.75 1.777v.304c-2.04.732-3.5 2.708-3.5 5.03v2.807c0 .48-.187.939-.52 1.277L5 16.252h4.375m5.25 0v.888c0 1.473-1.175 2.667-2.625 2.667s-2.625-1.194-2.625-2.667v-.889m5.25 0h-5.25",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render };